import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25SimpleCollapseComponent } from "./s25.simple.collapse.component";

@NgModule({
    declarations: [S25SimpleCollapseComponent],
    imports: [CommonModule, S25IconComponent],
    providers: [S25SimpleCollapseComponent],
    exports: [S25SimpleCollapseComponent],
})
export class S25SimpleCollapseModule {
    constructor() {}
}
